import { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useSettings } from '@/providers/SettingsProvider';
import { AppRouting } from '@/routing';
import { PathnameProvider, AbilityProvider, ToolbarProvider, SocketProvider } from '@/providers';
import { Toaster } from '@/components/ui/sonner';
import { useAbility } from '@/providers';
import { GTranslateBootstrap } from '@/i18n';
import 'leaflet/dist/leaflet.css';
import { getBasePath } from '@/utils/env';

const App = () => {
  const { settings } = useSettings();

  useEffect(() => {
    document.documentElement.classList.remove('dark');
    document.documentElement.classList.remove('light');
    document.documentElement.classList.add(settings.themeMode);
  }, [settings]);

  return <BrowserRouter basename={getBasePath()} future={{
    v7_relativeSplatPath: true,
    v7_startTransition: true
  }}>
      <AbilityProvider>
        <PathnameProvider>
            <ToolbarProvider>
              <SocketProvider>
                <AppRouting />
              </SocketProvider>
            </ToolbarProvider>
        </PathnameProvider>
      </AbilityProvider>
      {/* Preloads the Google Translate script. On mobile the picker lives in the
          drawer, which Radix unmounts when closed — without this the widget would
          have to fetch the script on first open. */}
      <GTranslateBootstrap />
      <Toaster closeButton richColors />
    </BrowserRouter>;
};
export { App };
